import { Iso2Country } from "@gymflow/types";
import { validatePhoneNumber, validatePostCode } from "@gymflow/validation";
import { DateTime } from "luxon";
import z from "zod";

export const generateMemberSchema = ({
  postcodeCountry,
}: {
  postcodeCountry: Iso2Country;
}) =>
  z
    .object({
      email: z.string().min(1, "common.required").email(),
      firstName: z.string().trim().min(2),
      lastName: z.string().trim().min(2),
      mobileNumber: z
        .string()
        .min(1, "common.required")
        .refine(
          (e) => {
            return validatePhoneNumber(e);
          },
          { message: `validation.phoneNumber` },
        ),

      dateBirth: z
        .date()
        .optional()
        .refine(
          (e) => {
            return e === undefined || DateTime.fromJSDate(e) < DateTime.now();
          },
          {
            message: "validation.beforeToday",
            params: {
              maximum: DateTime.now().toLocaleString(DateTime.DATE_MED),
            },
          },
        ),
      postCode: z
        .string()
        .optional()
        .refine(
          (e) => e === undefined || validatePostCode(e, postcodeCountry),
          { message: `validation.postCode` },
        ),
      addressLine1: z.string().trim().min(3).optional(),
      addressLine2: z.string().trim().optional(),
      city: z.string().trim().min(3).optional(),
      gender: z.enum(["MALE", "FEMALE", "PREFER_NOT_TO_SAY"]).optional(),
      emailCommunication: z.boolean(),
      smsCommunication: z.boolean(),
      pushCommunication: z.boolean(),
      emergencyContactName: z.string().min(3).optional(),
      emergencyContact: z
        .string()
        .optional()
        .refine((e) => e === undefined || validatePhoneNumber(e), {
          message: `validation.phoneNumber`,
        }),
      isClubWaiverAccepted: z.boolean(),
      personalNumber: z.string().optional(),
      picture: z
        .object({
          url: z.string().optional(),
          blob: z.any(),
        })
        .optional(),
    })
    .refine(
      (user) => {
        if (
          user.addressLine2 &&
          user.addressLine2?.length > 0 &&
          (!user.addressLine1 || user.addressLine1?.length === 0)
        ) {
          return false;
        }
        return true;
      },
      {
        path: ["addressLine1"],
        message: "validation.addressLine2RequiresAddressLine1",
      },
    )
    .refine(
      (user) => {
        if (!user.mobileNumber || !user.emergencyContact) {
          return true;
        }
        if (user.mobileNumber === user.emergencyContact) {
          return false;
        }
        return true;
      },
      {
        path: ["emergencyContact"],
        message: "validation.noDuplicateContact",
      },
    );
